// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PointSlider_slider-container__NVviG {
  width: 100%;
  padding-top: 1rem;
  text-align: center;
}

.PointSlider_background__TYOTe {
  height: 16px;
  border: 2px solid #eeeeee;
  border-radius: 8px;
  position: absolute;
  left: 0px;
  right: 0px;
}

.PointSlider_slider-label__2jejV {
  display: flex;
  justify-content: space-between;
}

.PointSlider_range__M90Tv {
  position: absolute;
  background-color: #eeeeee;
  height: 16px;
}

.PointSlider_container__Nk6oM {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.PointSlider_slider__O-OxG {
  appearance: none;
  height: 14px;
  background-color: transparent;
  position: relative;
  outline: none;
  z-index: 1;
}
.PointSlider_slider__O-OxG:disabled {
  cursor: not-allowed;
}
.PointSlider_slider__O-OxG:disabled::-webkit-slider-thumb {
  background-color: #cccccc;
  cursor: not-allowed;
}
.PointSlider_slider__O-OxG:disabled::-moz-range-thumb {
  background-color: #cccccc;
  cursor: not-allowed;
}

.PointSlider_slider__O-OxG::-webkit-slider-thumb {
  -webkit-appearance: none;
  background-color: #BCCF00;
  border: 1px solid white;
  height: 22px;
  width: 22px;
  border-radius: 50%;
  cursor: pointer;
}

.PointSlider_slider__O-OxG::-moz-range-thumb {
  height: 22px;
  width: 22px;
  border-radius: 50%;
  background-color: #BCCF00;
  border: 1px solid white;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/NodeInfo/PointSlider.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;AACF;AACE;EACE,mBAAA;AACJ;AACI;EACE,yBAAA;EACA,mBAAA;AACN;AAEI;EACE,yBAAA;EACA,mBAAA;AAAN;;AAKA;EACE,wBAAA;EACA,yBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAFF;;AAKA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;AAFF","sourcesContent":[".slider-container {\n  width: 100%;\n  padding-top: 1rem;\n  text-align: center;\n}\n\n.background {\n  height: 16px;\n  border: 2px solid #eeeeee;\n  border-radius: 8px;\n  position: absolute;\n  left: 0px;\n  right: 0px;\n}\n\n.slider-label {\n  display: flex;\n  justify-content: space-between;\n}\n\n.range {\n  position: absolute;\n  background-color: #eeeeee;\n  height: 16px;\n}\n\n.container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.slider {\n  appearance: none;\n  height: 14px;\n  background-color: transparent;\n  position: relative;\n  outline: none;\n  z-index: 1;\n}\n.slider:disabled {\n  cursor: not-allowed;\n}\n.slider:disabled::-webkit-slider-thumb {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n.slider:disabled::-moz-range-thumb {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  background-color: #BCCF00;\n  border: 1px solid white;\n  height: 22px;\n  width: 22px;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.slider::-moz-range-thumb {\n  height: 22px;\n  width: 22px;\n  border-radius: 50%;\n  background-color: #BCCF00;\n  border: 1px solid white;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"slider-container": `PointSlider_slider-container__NVviG`,
	"background": `PointSlider_background__TYOTe`,
	"slider-label": `PointSlider_slider-label__2jejV`,
	"range": `PointSlider_range__M90Tv`,
	"container": `PointSlider_container__Nk6oM`,
	"slider": `PointSlider_slider__O-OxG`
};
export default ___CSS_LOADER_EXPORT___;
